module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/tee/9-d3656bd8ba46873b5473d4f8bb5c3898.jpg";